<template>
  <span
    v-if="showCode"
    class="promo-code-badge"
    :title="title"
  >{{ label }}</span>
  <span
    v-else-if="showDiscount"
    class="promo-code-badge"
  >Скидка {{ discountAmount | amountWithCurrency }}</span>
</template>

<script>
  import PromoCodeAction from '@/models/enums/PromoCodeAction'

  /**
   * Переопределение отображения отдельных промокодов.
   * Ключ - код промокода, как он приходит из API (basket.promoCode.promoCode.code),
   * значение - подпись на плашке. Чего здесь нет, показывается как сам код.
   */
  export const PROMO_CODE_LABELS = {
    BIRTHDAY_RELATIVE: 'ДР БЛИЗКОГО',
    // BIRTHDAY: 'ДЕНЬ РОЖДЕНИЯ',
  }

  /**
   * Подпись плашки: переопределение по коду, иначе сам код,
   * иначе название (у промокодов начисления сеткоинов код пустой, есть только name).
   */
  export function promoCodeLabel (code, name = null) {
    return (code && PROMO_CODE_LABELS[code]) || code || name || '-'
  }

  /**
   * Плашка промокода или скидки заказа: единые базовые стили (пунктирная рамка, скругление),
   * единая таблица переопределений подписи и единое правило, что показывать.
   *
   * Правило: есть промокод - показываем его код (кроме оплаты фокскоинами, у неё своя плашка),
   * промокода нет, но есть скидка - показываем «Скидка N ₽», иначе ничего не рисуем.
   *
   * Размеры, цвет и отступы под конкретное место задаёт родитель своим классом на корне.
   */
  export default {
    name: 'PromoCodeBadge',
    props: {
      // Промокод корзины: basket.promoCode (ClientPromoCode с вложенным promoCode)
      promoCode: { type: Object, default: null },
      // Код строкой, когда объекта нет (например, order.promoCode из списка заказов)
      code: { type: String, default: null },
      discountAmount: { type: [Number, String], default: null },
      // Промокод оплаты фокскоинами не показывать: его рисует плашка foxcoins-pay
      hideFoxCoinPay: { type: Boolean, default: true },
    },
    computed: {
      rawCode () {
        return this.code || this.promoCode?.promoCode?.code || null
      },
      rawName () {
        return this.promoCode?.promoCode?.name || null
      },
      hasPromoCode () {
        return !!this.code || !!this.promoCode?.promoCode
      },
      isFoxCoinPay () {
        return this.promoCode?.promoCode?.action === PromoCodeAction.FoxCoinPay
      },
      showCode () {
        return this.hasPromoCode && !(this.hideFoxCoinPay && this.isFoxCoinPay)
      },
      showDiscount () {
        return !this.code && !this.promoCode && Number(this.discountAmount) > 0
      },
      label () {
        return promoCodeLabel(this.rawCode, this.rawName)
      },
      // Если подпись переопределена, в подсказке остаётся настоящий код
      title () {
        return this.rawCode && this.label !== this.rawCode ? this.rawCode : null
      },
    },
  }
</script>

<style scoped lang="less">
// Только вид плашки. Цвет рамки берётся из color родителя (currentColor),
// размер, отступы и позицию задаёт родитель своим классом на корне.
.promo-code-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  border-width: 1px;
  border-style: dashed;
  border-radius: 7px;
  text-align: center;
  line-height: 1.1;
  word-break: break-word;
}
</style>
